import { request } from 'apis/request';
import urls from 'apis/configure/urls';

const { apiUrlV1 } = urls;
export default function fetchConfiguration({ store }) {
  return request.get(`${apiUrlV1}/configuration/nonoco/?store=${store}`).then(res => res.data.results[0]);
}
